// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-91b886d6] .v-input__icon--append,[data-v-91b886d6] .v-input__icon--append-outer{cursor:pointer}[data-v-91b886d6] .required-suffix .v-text-field__suffix{color:#cb0f51!important}.reason-for-export-label[data-v-91b886d6],.reason-for-export-label>span[data-v-91b886d6]{color:var(--color-neutral-500)!important}.reason-for-export-label[data-v-91b886d6] .tooltip-wrap{pointer-events:auto}.reason-for-export-label[data-v-91b886d6] .tooltip-activator{margin-top:0}", ""]);
// Exports
module.exports = exports;
